import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import { loadClarity } from './app/core/analytics/clarity-loader';

if (environment.production) {
  loadClarity();
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
